import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import { CouponRedeemResponseSchema } from '@/schemas/v2/coupon'
import type { CouponRedeemResponse } from '@/schemas/v2/coupon'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

export type CouponRedeemParams = {
  /** CouponConfig.id（パスパラメータ） */
  couponConfigId: number
  /**
   * 特典クーポンの消込対象 user_reward_transactions.id（バックエンドで必須・未指定は 400）。
   * フロントの呼び出し経路は特典フローのみのため、指定漏れをコンパイル時に防ぐ目的で必須にしている。
   */
  userRewardTransactionId: number
  /** couponSpecificSpots=true のとき必須 */
  spotId?: number
}

/**
 * POST /api/v2/coupons/{couponConfigId}
 * 特典クーポンの消込。userRewardTransactionId と同一トランザクションで
 * user_reward_transactions が ACHIEVED → EXCHANGED に遷移する。
 */
export async function postCouponRedeem(
  { couponConfigId, userRewardTransactionId, spotId }: CouponRedeemParams,
  options?: FetchOptions,
): Promise<CouponRedeemResponse> {
  const url = `${BASE}/api/v2/coupons/${couponConfigId}`
  const body = {
    userRewardTransactionId,
    ...(spotId != null ? { spotId } : {}),
  }
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, body, options)
    return CouponRedeemResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
